import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Training from './Training';
import TrainingReader from './TrainingReader';

export const trainingRoutes: RouteObject[] = [
  { path: 'training', element: <Training /> },
  { path: 'training/:id', element: <TrainingReader /> },
];
